export function huf(value: number): string {
  return `${Math.round(value).toLocaleString('hu-HU')} Ft`
}

export function grams(value: number): string {
  return `${value.toFixed(1).replace('.', ',')} g`
}

export function duration(seconds: number): string {
  const total = Math.max(0, Math.round(seconds))
  const d = Math.floor(total / 86400)
  const h = Math.floor((total % 86400) / 3600)
  const m = Math.floor((total % 3600) / 60)

  const parts: string[] = []
  if (d) parts.push(`${d} nap`)
  if (h) parts.push(`${h} ó`)
  if (m || (!d && !h)) parts.push(`${m} p`)
  return parts.join(' ')
}

export function mm(value: number): string {
  return `${value.toFixed(0)} mm`
}
